
import Loading from 'vux/src/components/loading/index.vue'

import {login, register, bind} from '@/api/wechat'
import { removeToken } from '@/utils/auth'

export default {
name: "wechat-login",
components: {
Loading
},
mounted () {
console.log('login------')
this.wechatLogin();
},
data () {
return {
show: false
}
},
methods: {
async wechatLogin () {

removeToken();


let APP_ID = 'wx2bb9acd24a73bb3b';
const AUTHORIZE_URL = 'wx2.wuc.hlfcn.com%2fregister';
let authorizeUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + APP_ID + '&redirect_uri=https%3a%2f%2f' + AUTHORIZE_URL + '%2f&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect';


const uid = localStorage.getItem('wechatuid')
console.log('用户uid' + uid)

if (uid && uid !== 'undefined') {

this.show = true
login(uid).then(response => {
this.$router.push({path: '/bindUser'})
}).catch(error => {
console.log(error, "loginSub error");
this.show = false
window.location.href = authorizeUrl
});
} else {

window.location.href = authorizeUrl
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/wechat-login.vue